/**
 * Переходы за пределы приложения.
 *
 * Внутренняя навигация — дело react-router. Здесь только то, что
 * router не умеет: уход на другой хост. В нативной сборке это
 * открытие внешней ссылки, а не подмена window.location.
 */
export function replaceLocation(url) {
  globalThis.location.replace(url)
}

export function openExternal(url) {
  globalThis.open(url, '_blank', 'noopener,noreferrer')
}
